import React from 'react';
import styled from '@emotion/styled';
import Tooltip from '../tooltipV2/Tooltip';
import { colors, fontFamilies } from '../baseStyle/Variables';
import { useTranslation, Trans } from 'react-i18next';

type MonthlyPaymentContentProps = {
  monthlyPayment: string | null;
  payFrequency: string;
};

const MonthlyPaymentStyle = styled.div`
  color: ${colors.koalafiBlue};
  display: inline-block;
  div {
    font-family: ${fontFamilies.gilroyBold};
    font-size: 2.5rem;
    display: inline-block;
    margin-right: 0.3rem;
  }
  font-size: 0.9rem;
  font-family: ${fontFamilies.interLight};
`;

const MonthlyPaymentSubheader = styled.div`
  color: ${colors.darkBlue};
  font-size: 0.9rem !important;
  margin-top: 0.5rem;
  line-height: 125%;
  margin-bottom: 0.5rem;
  width: 95%;
`;
const MonthlyPaymentContent: React.FC<MonthlyPaymentContentProps> = ({ monthlyPayment, payFrequency }) => {
  const { t } = useTranslation();

  const paymentFrequencyLabels: { [index: string]: string } = {
    weekly: t(($) => $.componentContractSummaryParts.weekly),
    biweekly: t(($) => $.componentContractSummaryParts.biweekly),
    monthly: t(($) => $.componentContractSummaryParts.monthly),
    semimonthly: t(($) => $.componentContractSummaryParts.semimonthly),
  };

  const subheaderTooltip = <div>{t(($) => $.componentContractSummaryParts.leaseInitialTerm)}</div>;
  return (
    <div>
      {!!monthlyPayment && (
        <MonthlyPaymentStyle>
          <div>{monthlyPayment}</div>
          {paymentFrequencyLabels[payFrequency]}
        </MonthlyPaymentStyle>
      )}
      <MonthlyPaymentSubheader>
        <Trans
          i18nKey={($) => $.componentContractSummaryParts.paymentsStartAfterYourItemsShip}
          values={{ frequency: paymentFrequencyLabels[payFrequency] }}
          components={{ strong: <strong /> }}
        />
        <Tooltip id="subheader-tooltip" tooltipContent={subheaderTooltip} inline={true} size="12px" />
      </MonthlyPaymentSubheader>
    </div>
  );
};

export default MonthlyPaymentContent;
